export default __webpack_public_path__ + "static/media/load.bd7f98e8.svg";